// extracted by mini-css-extract-plugin
module.exports = {"diagram":"Diagram_diagram__3-slm","column":"Diagram_column__1YYLt"};